import { URLS } from "@app/shared";
import { PageHeader } from "@design-system/components";
import { getCurrentLocaleCode, trans } from "@mongez/localization";
import { toolLocales } from "../utils";

export function CompanyAnnouncementsPage() {
  const locale = getCurrentLocaleCode();
  const { standard } = toolLocales(locale);

  return (
    <>
      <PageHeader
        translationKey="companyAnnouncements"
        breadcrumbItems={[
          { label: trans("home"), link: URLS.home },
          { label: trans("investorRelations"), link: URLS.investor.root },
          { label: trans("companyAnnouncements") },
        ]}
      />
      <div className="container min-h-[calc(100vh-200px)] space-y-12 px-4 py-8">
        <euroland-tool
          data-tool-name="PressReleases"
          data-tool-language={standard}
        />
      </div>
    </>
  );
}
